'use strict';
app = angular.module('harriApp');

//<h-select
//h-name="i"
//h-model="i"
//h-options="cusine as cusine.label group by cusine.label for cusine in cusines"
//
//multiple="true"
//min-length="4"
//required="true"
//></h-select>
app.directive('hSelect', ["$filter", "deviceChecker", function ($filter, deviceChecker) {
    return {
        restrict: 'E',
        replace: (deviceChecker.isIE() || deviceChecker.isEdge() ? false: true),
        template: function (element, attr) {
            var formatAttr = "";

            if (attr.minimumInputLength) {
                formatAttr += ' minimum-input-length="' + attr.minimumInputLength + '" ';
            }

            if (attr.allowNewEntry) {
                formatAttr += ' allow-new-entry="' + attr.allowNewEntry + '" ';
            }

            if (attr.poweredByGoogle) {
                formatAttr += ' powered-by-google="' + attr.poweredByGoogle + '" ';
            }

            if (attr.newEntryPlaceholder) {
                formatAttr += ' new-entry-placeholder="' + attr.newEntryPlaceholder + '" ';
            }

            if (attr.selectedNewEntryPlaceholder) {
                formatAttr += ' selected-new-entry-placeholder="' + attr.selectedNewEntryPlaceholder + '" ';
            }

            if (attr.allowClear && (attr.allowClear == "true" || attr.allowClear == true)) {
                formatAttr += ' allow-clear="' + attr.allowClear + '" ';
            }

            if( attr.maximumSelectionLength && parseInt( attr.maximumSelectionLength ) > 0 ){
              formatAttr += ' maximum-selection-length="' + attr.maximumSelectionLength + '" ';
            }

            if( attr.hHideSearchControl ){
              formatAttr += ' h-hide-search-control="' + attr.hHideSearchControl + '" ';
            }

            if( attr.hShowResetSelection ){
              formatAttr += ' h-show-reset-selection="' + attr.hShowResetSelection + '" ';
            }

            if( attr.hMaxLimitMessage ){
              formatAttr += ' h-max-limit-message="' + attr.hMaxLimitMessage + '" ';
            }

            if (attr.ngDisabled) {
                formatAttr += ' ng-disabled="' + attr.ngDisabled + '" ';
            }

            //callbacks
            if (attr.delete) {
                formatAttr += ' delete="' + attr.delete + '" ';
            }
            if (attr.add) {
                formatAttr += ' add="' + attr.add + '" ';
            }

            if (attr.formatInputTooShort) {
                formatAttr += ' format-input-too-short="' + $filter("translate")(attr.formatInputTooShort) + '" ';
            }

            if (attr.dropDownCssClass) {
                formatAttr += ' drop-down-css-class="' + attr.dropDownCssClass + '" ';
            }

            if (attr.hNoFilteration) {
                formatAttr += ' h-no-filteration="' + attr.hNoFilteration + '" ';
            }

            if (attr.hName) {
                formatAttr += ' name="' + attr.hName + '" ';
            }

            if (attr.hModel) {
                formatAttr += ' ng-model="' + attr.hModel + '" ';
            }

            if (attr.required) {
                formatAttr += ' ng-required="' + attr.required + '" required="' + attr.required + '"';
            }

            if (attr.minLength) {
                formatAttr += ' min-length="' + attr.minLength + '" ';
            }

            if (attr.multiple && (attr.multiple == "true" || attr.multiple == true)) {
                formatAttr += ' multiple="' + attr.multiple + '" ';
            }

            if (attr.hOptions) {
                formatAttr += ' h-options="' + attr.hOptions + '" ';
            }

            if (attr.html) {
                formatAttr += ' html="' + attr.html + '" ';
            }

            if (attr.placeholder) {
                formatAttr += ' placeholder="' + $filter("translate")(attr.placeholder) + '" ';
            }


            if (attr.fullwidth && (attr.fullwidth == "true" || attr.fullwidth == true)) {
                formatAttr += ' fullwidth="' + attr.fullwidth + '" ';
            }

            if ( attr.onClearCall ){
              formatAttr += ' on-clear-call="'+attr.onClearCall+'" ';
            }

            if (attr.avoidDuplicatedResultsFrom) {
                formatAttr += ' avoid-duplicated-results-from="' + attr.avoidDuplicatedResultsFrom + '" ';
            }

            if (attr.avoidDuplicateOn) {
                formatAttr += ' avoid-duplicate-on="' + attr.avoidDuplicateOn + '" ';
            }

            if (attr.onOpen) {
              formatAttr += ' on-open="' + attr.onOpen + '" ';
            }

            if (attr.sfChanged) {
              formatAttr += ' sf-changed="' + attr.sfChanged + '" ';
            }

            if (attr.onChange) {
              formatAttr += ' on-change="' + attr.onChange + '" ';
            }

            if (attr.hChange) {
              formatAttr += ' ng-change="' + attr.hChange + '" ';
            }

            var randomId = 'random-id'+createUUID();
            formatAttr += ' container-selector="#'+randomId+'"';

            return '<span> ' +
                    '<span ><input ' + formatAttr + '  h-select type="hidden" /></span> ' +
                    '<span  class="relative-pos" id="'+randomId+'"></span>' +
                    '</span>';
        }
    }
}]);

//<span class="fullwidth">
// <input name="i" ng-model="i" ng-required="true"  min-length="2"   multiple="true"    ng-options="cusine as cusine.label group by cusine.label for cusine in cusines"  h-select  type="hidden" />
// </span>
app.directive('hSelect', ['$timeout', '$q', 'harriParseOptions', 'autoCompleteListTemplate', '$filter', '$parse', 'HCloseBodyMenu', 'hEvent', '$sanitize', function ($timeout, $q, $parseOptions, autoCompleteListTemplate, $filter, $parse, HCloseBodyMenu, hEvent, $sanitize) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: {
            post: function (scope, element, attr, controller) {
                var isHTML = (attr.html == "true" || attr.html == true);

                if (!attr.newEntryPlaceholder)
                    attr.newEntryPlaceholder = $filter("translate")("Create a new entry by typing here");

                var newEntryPlaceholder = $filter("translate")(attr.newEntryPlaceholder);


                if (attr.selectedNewEntryPlaceholder != undefined)
                    attr.selectedNewEntryPlaceholder = $filter('translate')('New entry');

                var selectedNewEntryPlaceholder = $filter("translate")(attr.selectedNewEntryPlaceholder);

                if (!attr.formatInputTooShort)
                    attr.formatInputTooShort = $filter('translate')('Start typing...');

                var formatInputTooShort = $filter("translate")(attr.formatInputTooShort);


                // Now we handle filteration from this file, in order to consider transaltion
                // attr.ngOptions = attr.ngOptions + ' | filter:$searchValue';
                var allowNewEntry = attr.allowNewEntry ? attr.allowNewEntry : "";
                var parsedOptions = $parseOptions(attr.hOptions, {}, allowNewEntry, autoCompleteListTemplate, newEntryPlaceholder);
                var $select = element;
                var cacheLatestResponse = [];
                var latestSelectedValue = {};
                var multiple = (attr.multiple == "true" || attr.multiple == true);
                var minimumInputLength = 0;

                if (attr.minimumInputLength && parseInt(attr.minimumInputLength) > 0) {
                    minimumInputLength = attr.minimumInputLength;
                }


                //parse init value to show the label based on ng-options
                function updateSelect2Value() {
                    var n = controller.$viewValue;
                    if (angular.isArray(n) && multiple) {
                        var values = [];
                        for (var k in n) {
                            values.push(parseModelsValueIntoSelect2Values(n[k]));
                        }
                        return values;
                    } else if (angular.isObject(n)) {
                        //parsed ng-options
                        var parsedValue = parseModelsValueIntoSelect2Values(n);
                        return parsedValue;
                    }

                    return "";
                }

                const getNestedProperty = (obj, queryname) => {
                    const tokens = queryname.split(".");
                    let result = obj;

                    for (let i = 0; i < tokens.length; i++) {
                        if (result?.[tokens[i]] !== undefined) {
                            result = result[tokens[i]];
                        } else {
                            return undefined;
                        }
                    }

                    return result;
                };

                function parseModelsValueIntoSelect2Values(n) {
                    var queryname = parsedOptions.$match[2];
                    var variableName = parsedOptions.$match[4];

                    //used `obj` to parse the value using eval
                    var obj = {};
                    obj[variableName] = n;

                    let name = "";
                    try {
                        name = getNestedProperty(obj , queryname);
                    } catch (e) {
                    }

                    return {text:  $filter('translate')(name), id: $filter('translate')(name), value: $filter('translate')(n) };
                }


                scope.$watch(attr.ngModel, function (n) {
                    if (n == undefined || (angular.isArray(n) && n.length === 0)) {
                        latestSelectedValue = n;
                        controller.$setViewValue(n);
                        updateSelect2Value();
                        $select.select2('val', n);

                        if( attr.hShowResetSelection === "true") {
                            $select.parent().find(".reset-selection").toggleClass("show-reset-selection", false);
                        }
                    }

                    //update select2 value only if it was changes from outside select2
                    if (!angular.equals(latestSelectedValue, n) &&
                        n != undefined &&
                        //not empty array
                        !(angular.isArray(n) && n.length === 0)) {

                        //change reference value, that would enable $dirty value in setViewValue
                        latestSelectedValue = angular.copy(n);
                        controller.$setViewValue(latestSelectedValue);

                        var value = updateSelect2Value();

                        if (value) {
                            $select.select2('val', value);
                            if( attr.hShowResetSelection === "true") {
                                $select.parent().find(".reset-selection").toggleClass("show-reset-selection", true);
                            }
                        } else {
                            $select.select2('val', '');
                            if( attr.hShowResetSelection === "true") {
                                $select.parent().find(".reset-selection").toggleClass("show-reset-selection", false);
                            }
                        }
                    }
                });

                var queryTimeout;

                var options = {
                    escapeMarkup: function (markup) {
                        return $sanitize(markup) || '';
                    },
                    //enable HTML outputs
                    formatResult: function (result, container, query, escapeMarkup) {
                        result.text = $filter('translate')(result.text);
                        var markup = [];
                        try {
                            if (result.newEntry) {
                                return result.text;
                            }
                            window.Select2.util.markMatch(result.text, query.term, markup, escapeMarkup);
                        } catch (e) {
                            return result.text;
                        }
                        return markup.join("");
                    },
                    formatSelection: function (data, container, escapeMarkup) {
                        if (data.newEntry) {
                            var value = data.newEntryValue;
                            //empty
                            if (!selectedNewEntryPlaceholder) {
                                return value;
                            }
                            return autoCompleteListTemplate({name: value, address: selectedNewEntryPlaceholder});
                        }
                        data.text = $filter('translate')(data.text);
                        var markup = [];
                        if (data.text) {
                            window.Select2.util.markMatch('' + data.text, '', markup, escapeMarkup);
                            if (data && data.value && data.value.locked) {
                                return "<span class='selected-tag locked'>" + markup.join("") + "</span>";
                            }
                        } else {
                            return data.text;
                        }
                        return markup.join("");
                    },
                    minimumInputLength: minimumInputLength,
                    placeholder: $filter("translate")(attr.placeholder),
                    formatInputTooShort: formatInputTooShort,
                    dropdownCssClass: scope.theme,
                    multiple: multiple,
                    id: function (e) {
                        if (e && e.value && e.value.id) {
                            return e.value.id
                        }

                        return e == undefined ? null : e.id;
                    },
                    query: function (query) {
                        $timeout.cancel(queryTimeout);

                        queryTimeout = $timeout(function () {

                            if (query && query.term && $.trim(query.term).length === 0) {
                                query.callback({results:[]});

                            } else {
                                controller.$searchValue = query.term && query.term.trim();

                                parsedOptions.valuesFn(scope, controller).then(function (values) {

                                    // Handle filteration for results, in order to consider translation

                                    var filterationFunction = function(results) {

                                        var filteredResults = [];

                                        if (results) {

                                            for (var i in results) {
                                                var passedFilter = false;

                                                if (results[i].children) {
                                                    results[i].children = filterationFunction(results[i].children);

                                                    if (results[i].children.length > 0) {
                                                        passedFilter = true;
                                                    }
                                                }
                                                else {
                                                    var displayText = $filter('translate')(results[i].text);

                                                    if (!displayText) {
                                                        passedFilter = true;
                                                        continue;
                                                    }

                                                    if (displayText.toString().toLowerCase().indexOf(query.term.toLowerCase().trim()) >= 0) {
                                                        passedFilter = true;
                                                    }
                                                }


                                                if (passedFilter) {
                                                    filteredResults.push(results[i]);
                                                }
                                            }

                                        }

                                        return filteredResults;
                                    }

                                    try {
                                        if (attr.hNoFilteration != 'true' && query.term.toLowerCase().trim()) {
                                            values.results = filterationFunction(values.results);
                                        }
                                    }
                                    catch (e) {
                                        console.error("Error while filteration:", e);
                                    }

                                    cacheLatestResponse = values;

                                    var hasResults = attr.allowNewEntry? 1: 0;

                                    if (values.results && values.results.length > hasResults) {
                                        if (attr.poweredByGoogle && element.parent().find(".poweredByGoogle").length == 0) {
                                            element.parent().find(".select2-results").after(
                                                "<div class='poweredByGoogle'>" +
                                                $filter("translate")("Powered By") + "<span class='google-logo'></span>" +
                                                "</div>"
                                            );
                                        }
                                    }
                                    else {
                                        element.parent().find(".poweredByGoogle").remove();
                                    }

                                    //remove external array duplicated
                                    values.results = removeDuplicatedResultsFromExternalArray(values.results);
                                    query.callback(values);
                                });
                            }
                        }, attr.poweredByGoogle? 800: 1);
                    },

                    initSelection: function (element, callback) {
                        var value = updateSelect2Value();
                        if (value) {
                            callback(value);

                            $timeout(function () {
                                validate();
                            })
                        }
                    }
                };

                if (attr.allowClear && (attr.allowClear == "true" || attr.allowClear == true)) {
                    options.allowClear = true;
                }

                if (attr.dropDownCssClass) {
                    options.dropdownCssClass = attr.dropDownCssClass;
                }

                if( attr.hHideSearchControl == "false"){
                  options.minimumResultsForSearch = -1;
                }

                if( attr.hShowResetSelection === "true") {
                    element.after('<i class="reset-selection fa fa-times" aria-hidden="true"></i>');
                    $select.parent().find(".reset-selection").toggleClass("show-reset-selection", true);
                    $select.parent().find(".reset-selection").on('click', function (e) {
                        $select.select2('val', '');
                        controller.$setViewValue("");
                        updateSelect2Value();
                        $select.parent().find(".reset-selection").toggleClass("show-reset-selection", false);
                    });
                }

                if (attr.fullwidth) {
                    options.width = "100%";
                }


                if( attr.containerSelector ){
                    options.containerSelector = attr.containerSelector;
                }

                if( multiple ) {
                    options.closeOnSelect = false;
                }

                if( attr.maximumSelectionLength && parseInt( attr.maximumSelectionLength ) > 0 ){
                  options.maximumSelectionSize =  attr.maximumSelectionLength;
                }

                if( attr.hMaxLimitMessage ){
                  options.formatSelectionTooBig =  attr.hMaxLimitMessage;
                }


                //actual select2
                $select.select2(options).on("change", function (e) {
                    //manage select2 changes over ngModel
                    $timeout(function () {

                        // Trigger on change handler if defined
                        if (attr.onChange && scope[attr.onChange]) {
                            scope[attr.onChange](e);
                        }

                        if (e.added) {
                            var value = e.added;

                            if (value.value) {
                                value = value.value;
                            }

                            //change reference value, that would enable $dirty value in setViewValue
                            value = angular.copy(value);

                            if (value.$$hashKey) {
                                delete value.$$hashKey;
                            }


                            if (multiple) {
                                var oldValue = controller.$viewValue;

                                if (!oldValue) {
                                    oldValue = [];
                                } else {
                                    //change reference value, that would enable $dirty value in setViewValue
                                    oldValue = angular.copy(controller.$viewValue);
                                }

                                oldValue.push(value);

                                if (attr.add) {
                                    var addFn = $parse(attr.add)(scope, controller);
                                    if (addFn) {
                                        addFn(value);
                                    }
                                }

                                latestSelectedValue = oldValue;
                                controller.$setViewValue(oldValue);
                            } else {
                                latestSelectedValue = value;
                                controller.$setViewValue(value);
                            }

                        } else if (e.removed) {
                            //remove
                            var value = e.removed;

                            if (value.value) {
                                value = value.value;
                            }

                            //change reference value, that would enable $dirty value in setViewValue
                            value = angular.copy(value);

                            if (value.$$hashKey) {
                                delete value.$$hashKey;
                            }

                            if (multiple) {
                                var oldValue = controller.$viewValue;

                                if (attr.delete) {
                                    var deleteFn = $parse(attr.delete)(scope, controller);
                                    if (deleteFn) {
                                        deleteFn(value);
                                    }
                                }

                                if (oldValue) {
                                    for (var k in oldValue) {
                                        if (_.isEqual(oldValue[k], value)) {
                                            var removed = oldValue.splice(k, 1);
                                        }
                                    }
                                }

                                if (!oldValue || oldValue.length == 0) {
                                    oldValue = "";
                                }

                                latestSelectedValue = oldValue;
                                controller.$setViewValue(oldValue);
                            } else {
                                latestSelectedValue = undefined;
                                controller.$setViewValue(undefined);
                            }

                            //Data Cleared
                            if( e.val == "" ){
                              scope.$apply(function() {
                                scope.$eval( attr.onClearCall );
                              });
                            }
                        }

                        validate();
                    });
                }).on('select2-open', function (e) {
                    hEvent.formEvent(element, 'enter', 'select2');

                    // Call onOpen callback if exists
                    if (attr.onOpen) {
                      var onOpenCallback = $parse(attr.onOpen)(scope, controller);
                      if (onOpenCallback) {
                        onOpenCallback();
                      }
                    }

                    // close body menu if its opened
                    if (HCloseBodyMenu.isOpened()) {
                        $select.select2('close');
                        HCloseBodyMenu.close(e, scope);
                    }


                    element.parent().find(".select2-input").on("keyup", function () {
                        if ($(this).val().length < 2) {
                            element.parent().find(".poweredByGoogle").remove();
                        }
                    });

                    if( attr.hShowResetSelection === "true") {
                        $select.parent().find(".reset-selection").toggleClass("show-reset-selection", false);
                    }

                }).on("select2-blur", function (e) {
                    controller.$touched = true;
                    //show errors
                    if (!controller.$valid) {
                        element.closest('.form-group').addClass('has-error');
                    }
                    validate();
                }).on("select2-selecting", function (e) {
//                    setTimeout(function () {
//                        document.activeElement.blur();
//                    }, 500);
                }).on('select2-close', function (e) {
                    controller.$touched = true;
                    var trackObj = {multiple:multiple};

                    if(multiple) {
                        latestSelectedValue = latestSelectedValue || [];
                        trackObj.items = latestSelectedValue.length;
                    } else {
                        trackObj.length = ($select.val() || "").length;
                    }

                    hEvent.formEvent(element, 'exit', 'select2', trackObj);

                    if( attr.hShowResetSelection === "true" && ($select.val() || "").length) {
                        $select.parent().find(".reset-selection").toggleClass("show-reset-selection", true);
                    }

                    setTimeout(function () {
                        $('.select2-container-active').removeClass('select2-container-active');
                        $(':focus').blur();
                        //$select
                    }, 100);

                    element.parent().find(".select2-input").off("keyup");
                });


                validate();

                function validate() {
                    //validate min selection
                    if (attr.minLength && multiple) {
                        var min = parseInt(attr.minLength);
                        var length = (controller.$viewValue && controller.$viewValue.length) || 0;

                        controller.$setValidity('minLength', length >= min);
                    }

                    if (controller.$valid) {
                        $(element).closest('.form-group').removeClass('has-error');

                    }
                }


                function getLabelBasedOnHOptionsQuery(n) {
                    var queryname = parsedOptions.$match[2];
                    var variableName = parsedOptions.$match[4];

                    //used `obj` to parse the value using eval
                    var obj = {};
                    obj[variableName] = n;

                    let name = "";
                    try {
                        name = getNestedProperty(obj, queryname);
                    } catch (e) {
                    }

                    return name;
                }

                //a case where selected results are stored externally, the following code is to avoid duplication
                function removeDuplicatedResultsFromExternalArray(queryResult) {
                    //external array that hold a list of what's selected, used in work history, locations, educations
                    var externalSelectedList = [];
                    if (attr.avoidDuplicatedResultsFrom) {
                        externalSelectedList = $parse(attr.avoidDuplicatedResultsFrom)(scope, controller);
                    }

                    if (externalSelectedList && angular.isArray(externalSelectedList) &&
                        externalSelectedList.length > 0) {


                        //remove duplicated options
                        var newList = [];
                        for (var k in queryResult) {
                            var found = false;
                            for (var kk in externalSelectedList) {
//                                console.log((queryResult[k]) , (externalSelectedList[kk]));
                                // If the field to avoid duplicate on is defined - use it
                                if (attr.avoidDuplicateOn) {
                                  if (queryResult[k].value[attr.avoidDuplicateOn] == externalSelectedList[kk][attr.avoidDuplicateOn]) {
                                    found = true;
                                  }
                                }
                                // Else use the field based on hOptions query
                                else if (getLabelBasedOnHOptionsQuery(queryResult[k].value) == getLabelBasedOnHOptionsQuery(externalSelectedList[kk])) {
                                    found = true;

                                    //handle new entry
                                } else if (
                                    queryResult[k].newEntry && (
                                    queryResult[k].newEntryValue == externalSelectedList[kk].value ||
                                    angular.equals(queryResult[k].value, externalSelectedList[kk].value)
                                    )
                                    ) {

                                    found = true;
                                }

                            }

                            if (!found) {
                                newList.push(queryResult[k]);
                            }
                        }

                        queryResult = newList;
                    }

                    return queryResult;

                }


            }
        }
    };
}]);


//https://github.com/mgcrea/angular-strap/blob/master/src/helpers/parse-options.js
app.provider('harriParseOptions', function () {

    var defaults = this.defaults = {
        regexp: /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(.*?)(?:\s+track\s+by\s+(.*?))?$/
    };

    this.$get = ["$parse", "$q", function ($parse, $q) {
        function ParseOptionsFactory(attr, config, allowNewEntry, autoCompleteListTemplate, newEntryPlaceholder) {

            var $parseOptions = {};

            // Common vars
            var options = angular.extend({}, defaults, config);
            $parseOptions.$values = [];

            // Private vars
            var match, displayFn, valueName, keyName, groupByFn, valueFn, valuesFn;

            $parseOptions.init = function () {
                $parseOptions.$match = match = attr.match(options.regexp);
                displayFn = $parse(match[2] || match[1]),
                    valueName = match[4] || match[6],
                    keyName = match[5],
                    groupByFn = $parse(match[3] || ''),
                    valueFn = $parse(match[2] ? match[1] : valueName),
                    valuesFn = $parse(match[7]);
            };

            $parseOptions.valuesFn = function (scope, controller) {

                var valueFnResult = valuesFn(scope, controller);

                //watch the variable and assign the value on the fly when ever the model changed
                //show loading if the variable is undefined
                if (valueFnResult == undefined) {
                    var defer = $q.defer();

                    var unbindWatcher = scope.$watch(function () {

                        return valuesFn(scope, controller);

                    }, function (n) {

                        valueFnResult = n;
                        if (valueFnResult != undefined) {
                            unbindWatcher();
                            defer.resolve(valueFnResult);
                        }

                    });
                    valueFnResult = defer.promise;
                }

                return $q.when(valueFnResult)
                    .then(function (values) {
                        //changed to match select2 structure
                        $parseOptions.$values = values ? parseValues(values, scope, controller) : [];

                        var grouped = false;
                        if (match[3]) {
                            grouped = true;
                            $parseOptions.$values = groupBy($parseOptions.$values);
                        }

                        //changed to match select2 structure
                        return {more: false, results: $parseOptions.$values, grouped: grouped};
                    });
            };

            //changed - created based on select2 needs
            function groupBy(values) {
                var groups = [];
                var groupKeys = {};

                _.each(values, function (option) {
                    var group = "";

                    if (option.group) {
                        group = option.group;
                    }

                    //grouping
                    var index = 0;
                    if (groupKeys[group] >= 0) {
                        index = groupKeys[group];
                    } else {
                        groups.push({text: group, children: []});
                        index = groups.length - 1;
                        groupKeys[group] = index;
                    }

                    groups[index].children.push(option);
                });

                return groups;
            }

            // Private functions
            function parseValues(values, scope, controller) {

                if (typeof(values) != "object") {
                    console.error("Coolautocomplete values is not valid, expecting object but found:", values);
                    values = [];
                }

                var values = values.map(function (match, index) {
                    var locals = {}, label, value, group;
                    locals[valueName] = match;
                    label = displayFn(scope, locals);
                    value = valueFn(scope, locals) || index;

                    //change to add grouping
                    group = groupByFn(scope, locals);

                    //change to math select2 structure
                    return {text: label, value: value, id: label, group: group};
                });


                if (allowNewEntry && allowNewEntry != "") {
                    var obj = {};
                    var value = controller.$searchValue;
                    if (value != "") {
                        obj[allowNewEntry] = value;

                        var text = autoCompleteListTemplate({name: value, address: newEntryPlaceholder});
                        var option = {value: obj, text: text, id: text, newEntry: true, newEntryValue: value};

                        values.unshift(option);
                    }
                }

                return values;
            }

            $parseOptions.init();
            return $parseOptions;

        }

        return ParseOptionsFactory;

    }];

});

app.directive('hDisabled', ['$parse', function () {
    return {
        link: function (scope, element, attrs) {
            scope.$watch(attrs.hDisabled, function (n) {
                if (n === true) {
                    element.find('input[h-select]').select2("enable", true);
                } else if (n === false) {
                    element.find('input[h-select]').select2("enable", false);
                }
            })
        }
    }
}])
